import React from "react";
import Popup from "~/assets/js/components/Popup";
import i18n from "~/assets/js/Helpers/i18n";
import Button from "~/assets/js/components/Button";
import CloseIcon from "~/static/images/icons/close.svg";
import { Info } from "react-feather";
import PropTypes from "prop-types";

const GreenClubCapacityPopUp = ({ open: propOpen, handleClose }) => {
    const PopupConfig = {
        customStyle: "green-club-capacity",
        open: propOpen,
        handleClose: handleClose,
    };

    return (
        <Popup {...PopupConfig}>
            <div className="green-club-capacity__close">
                <img
                    src={CloseIcon}
                    className="green-club-capacity__close__infoicon"
                    onClick={handleClose}
                    alt={"gc-close"}
                />
            </div>
            <div className="green-club-capacity__logo">
                <Info className="green-club-capacity__logo__infoicon" />
            </div>

            <div className="green-club-capacity__content">
                <p className="green-club-capacity__content__heading">
                    {i18n.t("productDetails.greenClub.capacityPopup.header")}
                </p>
                <p className="green-club-capacity__content__content">
                    {i18n.t("productDetails.greenClub.capacityPopup.content")}
                </p>
            </div>
            <div className="green-club-capacity__actions">
                <Button
                    label={i18n.t("productDetails.greenClub.capacityPopup.cta")}
                    size="LG"
                    variant="secondary"
                    onClick={handleClose}
                />
            </div>
        </Popup>
    );
};

GreenClubCapacityPopUp.propTypes = {
    initialOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    open: PropTypes.bool,
};

export default GreenClubCapacityPopUp;
